export default "__VITE_PUBLIC_ASSET__02e8fa55__"